module.exports = __webpack_public_path__ + "img/history_black.4cd55aea.svg";